import type { WorkingUnitsNumber } from "../../common";

export class PaymentConfigRefUsageDataJSON {
  flatFee?: {
    amount: WorkingUnitsNumber;
    quantity: number;
  };
  ecommerceData?: {
    treeCount: number;
    treePrice: number;
    co2eCount?: number;
    co2ePrice?: number;
    plasticCount?: number;
    plasticPrice?: number;
  };
  minUsageThreshold?: {
    // top-up counts folded into ecommerceData.<type>Count (0 when no top-up applied)
    treeCount: number;
    co2eCount: number;
    plasticCount: number;
    // threshold-derivation metadata (how the threshold was evaluated)
    minThresholdAmount: WorkingUnitsNumber;
    source: "direct" | "usd-converted";
    // present only when source === 'usd-converted'
    minThresholdUSD?: number;
    fromUsdConversionRate?: number;
  };
}
